
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import MobileBottomNav from '../../components/MobileBottomNav';

const ManageCourseLecturerPage = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);


  const [activeTab, setActiveTab] = useState('lecturer');


  const [lecturers, setLecturers] = useState([]);
  const [lecturersLoading, setLecturersLoading] = useState(false);
  const [lecturersError, setLecturersError] = useState('');
  const [lecturersInfo, setLecturersInfo] = useState('');
  const [lecturersSearch, setLecturersSearch] = useState('');

  const [editLecturerId, setEditLecturerId] = useState(null);
  const [editLecturerData, setEditLecturerData] = useState({
    name: '',
    email: '',
    college: '',
    department: '',
    position: '',
  });
  const [editLecturerLoading, setEditLecturerLoading] = useState(false);


  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [coursesError, setCoursesError] = useState('');
  const [coursesInfo, setCoursesInfo] = useState('');
  const [coursesSearch, setCoursesSearch] = useState('');

  const [editCourseId, setEditCourseId] = useState(null);
  const [editCourseData, setEditCourseData] = useState({
    name: '',
    code: '',
    college: '',
    department: '',
  });
  const [editCourseLoading, setEditCourseLoading] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsMobile(w < 768);
      setIsTablet(w >= 768 && w < 1024);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  const fetchLecturers = async () => {
    setLecturersLoading(true);
    setLecturersError('');
    try {
      const resp = await fetch('/api/lecturers', {
        credentials: 'include',
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();
      setLecturers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error loading lecturers:', err);
      setLecturersError('تعذر تحميل قائمة المحاضرين. تأكد من الخادم.');
    } finally {
      setLecturersLoading(false);
    }
  };


  const fetchCourses = async () => {
    setCoursesLoading(true);
    setCoursesError('');
    try {
      const resp = await fetch('/api/courses', {
        credentials: 'include',
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();
      setCourses(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error loading courses:', err);
      setCoursesError('تعذر تحميل قائمة المقررات. تأكد من الخادم.');
    } finally {
      setCoursesLoading(false);
    }
  };


  useEffect(() => {
    fetchLecturers();
    fetchCourses();
  }, []);


  const normalize = (s) => (s || '').toString().toLowerCase();

  const filteredLecturers = lecturers.filter((l) => {
    if (!lecturersSearch.trim()) return true;
    const q = normalize(lecturersSearch);
    return (
      normalize(l.name).includes(q) ||
      normalize(l.email).includes(q) ||
      normalize(l.college).includes(q) ||
      normalize(l.department).includes(q) ||
      normalize(l.position).includes(q)
    );
  });

  const filteredCourses = courses.filter((c) => {
    if (!coursesSearch.trim()) return true;
    const q = normalize(coursesSearch);
    return (
      normalize(c.name).includes(q) ||
      normalize(c.code).includes(q) ||
      normalize(c.college).includes(q) ||
      normalize(c.department).includes(q)
    );
  });


  const startEditLecturer = (lecturer) => {
    setLecturersInfo('');
    setLecturersError('');
    setEditLecturerId(lecturer.id);
    setEditLecturerData({
      name: lecturer.name || '',
      email: lecturer.email || '',
      college: lecturer.college || '',
      department: lecturer.department || '',
      position: lecturer.position || '',
    });
  };

  const cancelEditLecturer = () => {
    setEditLecturerId(null);
    setEditLecturerData({
      name: '',
      email: '',
      college: '',
      department: '',
      position: '',
    });
  };

  const handleEditLecturerChange = (field, value) => {
    setEditLecturerData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveLecturerEdit = async () => {
    if (!editLecturerId) return;
    setLecturersError('');
    setLecturersInfo('');
    if (!editLecturerData.name.trim()) {
      setLecturersError('اسم المحاضر مطلوب.');
      return;
    }
    if (!editLecturerData.position.trim()) {
      setLecturersError('المسمى الوظيفي مطلوب.');
      return;
    }

    try {
      setEditLecturerLoading(true);
      const resp = await fetch(`/api/lecturers/${editLecturerId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editLecturerData),
      });
      if (!resp.ok) {
        const text = await resp.text();
        console.error('Update lecturer failed:', resp.status, text);
        throw new Error(`HTTP ${resp.status}`);
      }
      const data = await resp.json();
      const updated = data?.lecturer || data;

      setLecturers((prev) =>
        prev.map((l) => (l.id === editLecturerId ? { ...l, ...updated } : l))
      );
      setLecturersInfo('تم تحديث بيانات المحاضر بنجاح.');
      cancelEditLecturer();
    } catch (err) {
      console.error('Error updating lecturer:', err);
      setLecturersError('حدث خطأ أثناء تحديث بيانات المحاضر.');
    } finally {
      setEditLecturerLoading(false);
    }
  };


  const deleteLecturer = async (lecturerId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المحاضر من النظام؟')) return;
    setLecturersError('');
    setLecturersInfo('');
    try {
      const resp = await fetch(`/api/lecturers/${lecturerId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      setLecturers((prev) => prev.filter((l) => l.id !== lecturerId));
      setLecturersInfo('تم حذف المحاضر بنجاح.');
      if (editLecturerId === lecturerId) cancelEditLecturer();
    } catch (err) {
      console.error('Error deleting lecturer:', err);
      setLecturersError('حدث خطأ أثناء حذف المحاضر.');
    }
  };


  const startEditCourse = (course) => {
    setCoursesError('');
    setCoursesInfo('');
    setEditCourseId(course.id);
    setEditCourseData({
      name: course.name || '',
      code: course.code || '',
      college: course.college || '',
      department: course.department || '',
    });
  };

  const cancelEditCourse = () => {
    setEditCourseId(null);
    setEditCourseData({
      name: '',
      code: '',
      college: '',
      department: '',
    });
  };

  const handleEditCourseChange = (field, value) => {
    setEditCourseData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveCourseEdit = async () => {
    if (!editCourseId) return;
    setCoursesError('');
    setCoursesInfo('');
    if (!editCourseData.name.trim()) {
      setCoursesError('اسم المقرر مطلوب.');
      return;
    }

    try {
      setEditCourseLoading(true);
      const resp = await fetch(`/api/courses/${editCourseId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editCourseData),
      });
      if (!resp.ok) {
        const text = await resp.text();
        console.error('Update course failed:', resp.status, text);
        throw new Error(`HTTP ${resp.status}`);
      }
      const data = await resp.json();
      const updated = data?.course || data;

      setCourses((prev) =>
        prev.map((c) => (c.id === editCourseId ? { ...c, ...updated } : c))
      );
      setCoursesInfo('تم تحديث بيانات المقرر بنجاح.');
      cancelEditCourse();
    } catch (err) {
      console.error('Error updating course:', err);
      setCoursesError('حدث خطأ أثناء تحديث بيانات المقرر.');
    } finally {
      setEditCourseLoading(false);
    }
  };


  const deleteCourse = async (courseId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المقرر من النظام؟')) return;
    setCoursesError('');
    setCoursesInfo('');
    try {
      const resp = await fetch(`/api/courses/${courseId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      setCourses((prev) => prev.filter((c) => c.id !== courseId));
      if (editCourseId === courseId) cancelEditCourse();
      setCoursesInfo('تم حذف المقرر بنجاح.');
    } catch (err) {
      console.error('Error deleting course:', err);
      setCoursesError('حدث خطأ أثناء حذف المقرر.');
    }
  };


  const formCardStyle = {
    borderRadius: 20,
    border: '1px solid rgba(40,227,218,.22)',
    background: 'radial-gradient(55% 100% at 50% -5%,rgba(40,227,218,.14) 0%,rgba(40,227,218,0) 60%),rgba(9,28,43,.9)',
    boxShadow: '0 8px 32px rgba(0,0,0,.35)',
    backdropFilter: 'blur(6px)',
    padding: '18px 18px 22px',
  };

  const toggleButtonStyle = (isActive) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    borderRadius: 14,
    fontFamily: 'Alexandria',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    border: isActive ? '1px solid rgba(8,20,35,.6)' : '1px solid rgba(211,216,218,0.7)',
    background: isActive
      ? 'linear-gradient(135deg,#28E3DA,#7DF9E8)'
      : 'rgba(213,210,210,0.15)',
    color: isActive ? '#081423' : '#D5D2D2',
    cursor: 'pointer',
    minWidth: 140,
  });

  const inputStyle = {
    width: '100%',
    height: '42.75px',
    background: '#12334A',
    borderRadius: '12px',
    border: '1px solid rgba(255,255,255,0.08)',
    outline: 'none',
    color: '#FFFFFF',
    padding: '0 16px',
    fontSize: '14px',
    fontFamily: 'Alexandria',
    direction: 'rtl',
  };

  const smallButtonBase = {
    borderRadius: 999,
    padding: '5px 10px',
    fontSize: '11px',
    fontFamily: 'Alexandria',
    fontWeight: 700,
    border: '0.75px solid transparent',
    cursor: 'pointer',
  };

  return (
    <div
      className="min-h-screen text-white bg-transparent"
      style={{
        direction: 'rtl',
        display: 'flex',
        flexDirection: 'row',
        background:
          'linear-gradient(0deg, rgba(255,255,255,0.02), rgba(255,255,255,0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40,227,218,0.16) 0%, rgba(40,227,218,0) 100%), #081423',
      }}
    >
      {                     }
      <div className="hidden md:block sticky top-0 h-screen z-[200]">
        <Sidebar isOpen={isSidebarOpen} onClose={setIsSidebarOpen} />
      </div>

      {                    }
      <div className="md:hidden">
        <Sidebar isOpen={isSidebarOpen} onClose={setIsSidebarOpen} />
      </div>

      {                  }
      <div
        className="flex-1 flex flex-col md:ml-0"
        style={{ width: '100vw', marginLeft: isMobile ? '0' : 'auto' }}
      >
        <div
          className="flex-1 p-6 pb-20 md:pb-6"
          style={{
            maxWidth: '100%',
            padding: isMobile ? '16px 12px 80px' : isTablet ? '20px 24px 24px' : '24px 48px 32px',
          }}
        >
          {             }
          <nav style={{
            display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-start' : 'space-evenly',
            flexWrap: 'wrap', gap: isMobile ? '6px' : '4px',
            padding: isMobile ? '10px 12px' : '0 16px',
            height: isMobile ? 'auto' : '52px',
            background: 'radial-gradient(43.64% 77.08% at 50% -10.42%,rgba(40,227,218,.2) 0%,rgba(40,227,218,0) 100%),rgba(9,28,43,.6)',
            border: '1px solid rgba(40,227,218,.2)',
            borderRadius: '16px',
            backdropFilter: 'blur(4px)',
            marginBottom: '24px',
          }}>
            {[
              { label: 'نظرة عامة',           path: '/dashboard' },
              { label: 'إدارة المستخدمين',    path: '/user-management' },
              { label: 'سجل النشاط',          path: '/activity-log' },
              { label: 'الإبلاغات',           path: '/reports' },
              { label: 'إضافة مقرر / محاضر', path: '/add-course-lecturer' },
              { label: 'إدارة المقررات',      active: true },
            ].map((item, i) => (
              <React.Fragment key={item.label}>
                {i > 0 && !isMobile && <span style={{ color: 'rgba(255,255,255,.15)', fontSize: '18px', userSelect: 'none' }}>|</span>}
                <span
                  onClick={() => item.path && navigate(item.path)}
                  style={{
                    fontFamily: 'Alexandria,sans-serif', fontSize: isMobile ? '12px' : '14px',
                    fontWeight: item.active ? 800 : 500, color: item.active ? '#7DF9E8' : '#94a3b8',
                    cursor: item.path ? 'pointer' : 'default',
                    padding: isMobile ? '5px 10px' : '0 4px', borderRadius: isMobile ? '8px' : 0,
                    background: item.active && isMobile ? 'rgba(40,227,218,.1)' : 'transparent',
                    transition: 'color .15s', whiteSpace: 'nowrap',
                  }}
                  onMouseEnter={e => { if (item.path) e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={e => { if (item.path) e.currentTarget.style.color = '#94a3b8'; }}
                >{item.label}</span>
              </React.Fragment>
            ))}
          </nav>

          {                         }
          <div className="flex justify-center mb-8">
            <div
              className="inline-flex items-center gap-2 rounded-[18px] px-2 py-2"
              style={{
                direction: 'rtl',
                border: '1px solid rgba(40,227,218,.22)',
                background: 'radial-gradient(55% 100% at 50% -5%,rgba(40,227,218,.14) 0%,rgba(40,227,218,0) 60%),rgba(9,28,43,.9)',
                boxShadow: '0 8px 32px rgba(0,0,0,.35)',
                backdropFilter: 'blur(6px)',
              }}
            >
              <button
                type="button"
                onClick={() => setActiveTab('lecturer')}
                style={toggleButtonStyle(activeTab === 'lecturer')}
              >
                إدارة المحاضرين
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('course')}
                style={toggleButtonStyle(activeTab === 'course')}
              >
                إدارة المقررات
              </button>
            </div>
          </div>

          {             }
          <div className="px-4">
            {                                 }
            {activeTab === 'lecturer' && (
              <div className="w-full max-w-3xl mx-auto space-y-5">
                <div style={formCardStyle}>
                  <div
                    className="mb-4 flex flex-col items-end"
                    style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}
                  >
                    <h2
                      style={{
                        fontFamily: 'Alexandria',
                        fontWeight: 700,
                        fontSize: '13px',
                        marginBottom: 6,
                      }}
                    >
                      إدارة المحاضرين
                    </h2>
                    <p
                      style={{
                        fontFamily: 'Alexandria',
                        fontWeight: 500,
                        fontSize: '11px',
                        color: '#D5D2D2',
                        maxWidth: '480px',
                      }}
                    >
                      يمكنك البحث عن أي محاضر، ثم تعديل بياناته أو حذفه من قاعدة البيانات
                      NameDoctors.DoctorViews.
                    </p>
                  </div>

                  {         }
                  <div style={{ direction: 'rtl' }} className="mb-3">
                    <label className="block text-xs font-medium mb-1 text-right">
                      البحث عن محاضر
                    </label>
                    <input
                      type="text"
                      placeholder="ابحث بالاسم، البريد، الكلية، القسم، المسمى الوظيفي..."
                      value={lecturersSearch}
                      onChange={(e) => setLecturersSearch(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  {           }
                  {lecturersInfo && (
                    <div className="mb-3 rounded-xl border border-emerald-500/60 bg-emerald-500/10 px-3 py-2 text-[12px] text-emerald-100 text-right">
                      {lecturersInfo}
                    </div>
                  )}
                  {lecturersError && (
                    <div className="mb-3 rounded-xl border border-rose-500/60 bg-rose-500/10 px-3 py-2 text-[12px] text-rose-100 text-right">
                      {lecturersError}
                    </div>
                  )}

                  {lecturersLoading ? (
                    <div className="text-center text-sm text-slate-200 mt-4">
                      جاري تحميل المحاضرين...
                    </div>
                  ) : filteredLecturers.length === 0 ? (
                    <div className="text-center text-sm text-slate-300 mt-4">
                      لا يوجد محاضرين مطابقين لشرط البحث.
                    </div>
                  ) : (
                    <div
                      className="space-y-3 mt-4"
                      style={{ direction: 'rtl', maxHeight: '520px', overflowY: 'auto' }}
                    >
                      {filteredLecturers.map((lec) => {
                        const isEditing = editLecturerId === lec.id;
                        return (
                          <div
                            key={lec.id}
                            className="px-3 py-3 text-[12px]"
                          style={{ background: 'radial-gradient(55% 100% at 50% -5%,rgba(40,227,218,.10) 0%,rgba(40,227,218,0) 60%),rgba(9,28,43,.9)', border: '1px solid rgba(40,227,218,.22)', borderRadius: '14px', boxShadow: '0 4px 16px rgba(0,0,0,.25)' }}
                          >
                            <div
                              className="flex justify-between items-center mb-2 gap-2"
                              style={{ direction: 'rtl' }}
                            >
                              {               }
                              <div
                                className="flex flex-col flex-1 text-right"
                                style={{ textAlign: 'right' }}
                              >
                                <div className="flex items-center gap-2 mb-1 justify-end">
                                  <span className="text-white font-semibold">
                                    {lec.name}
                                  </span>
                                  {lec.position && (
                                    <span className="px-2 py-[2px] rounded-full text-[10px] bg-cyan-500/10 border border-cyan-400/50 text-cyan-100">
                                      {lec.position}
                                    </span>
                                  )}
                                </div>
                                <div className="text-[#B8C5CE]">
                                  {lec.college || 'كلية غير محددة'} •{' '}
                                  {lec.department || 'قسم غير محدد'}
                                </div>
                                {lec.email && (
                                  <div className="text-[#9FB4C4] mt-[2px]">
                                    البريد: {lec.email}
                                  </div>
                                )}
                              </div>

                              {                  }
                              <div className="flex flex-col gap-2 items-start">
                                <button
                                  type="button"
                                  onClick={() =>
                                    isEditing ? cancelEditLecturer() : startEditLecturer(lec)
                                  }
                                  style={{
                                    ...smallButtonBase,
                                    borderColor: 'rgba(40,227,218,.7)',
                                    background: isEditing
                                      ? 'rgba(40,227,218,.1)'
                                      : 'linear-gradient(135deg,#28E3DA,#7DF9E8)',
                                    color: isEditing ? '#7DF9E8' : '#081423',
                                  }}
                                >
                                  {isEditing ? 'إلغاء' : 'تعديل'}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => deleteLecturer(lec.id)}
                                  style={{
                                    ...smallButtonBase,
                                    borderColor: 'rgba(248,113,113,.7)',
                                    background: 'rgba(127,29,29,.9)',
                                    color: '#FEE2E2',
                                  }}
                                >
                                  حذف
                                </button>
                              </div>
                            </div>

                            {                                    }
                            {isEditing && (
                              <div
                                className="mt-3 pt-3 border-t border-white/5"
                                style={{ direction: 'rtl' }}
                              >
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      اسم المحاضر
                                    </label>
                                    <input
                                      type="text"
                                      value={editLecturerData.name}
                                      onChange={(e) =>
                                        handleEditLecturerChange('name', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      البريد الإلكتروني
                                    </label>
                                    <input
                                      type="email"
                                      value={editLecturerData.email}
                                      onChange={(e) =>
                                        handleEditLecturerChange('email', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      الكلية
                                    </label>
                                    <input
                                      type="text"
                                      value={editLecturerData.college}
                                      onChange={(e) =>
                                        handleEditLecturerChange('college', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      القسم
                                    </label>
                                    <input
                                      type="text"
                                      value={editLecturerData.department}
                                      onChange={(e) =>
                                        handleEditLecturerChange('department', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      المسمى الوظيفي
                                    </label>
                                    <select
                                      value={editLecturerData.position}
                                      onChange={(e) =>
                                        handleEditLecturerChange('position', e.target.value)
                                      }
                                      style={inputStyle}
                                    >
                                      <option value="">اختر المسمى</option>
                                      <option value="محاضر">محاضر</option>
                                      <option value="مدرس">مدرس</option>
                                      <option value="أستاذ">أستاذ</option>
                                      <option value="معيد">معيد</option>
                                      <option value="أستاذ مشارك">أستاذ مشارك</option>
                                      <option value="أستاذ مساعد">أستاذ مساعد</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="flex justify-center mt-3 gap-3">
                                  <button
                                    type="button"
                                    onClick={saveLecturerEdit}
                                    disabled={editLecturerLoading}
                                    className="px-5 py-2 rounded-[14px] text-[12px] font-bold"
                                    style={{
                                      border: '0.75px solid rgba(40,227,218,0.6)',
                                      background: editLecturerLoading
                                        ? 'rgba(40,227,218,0.25)'
                                        : 'linear-gradient(135deg,#28E3DA,#7DF9E8)',
                                      color: '#081423',
                                      boxShadow: '0 0 18px rgba(40,227,218,.55)',
                                      opacity: editLecturerLoading ? 0.8 : 1,
                                    }}
                                  >
                                    {editLecturerLoading ? 'جاري الحفظ...' : 'حفظ التعديل'}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={cancelEditLecturer}
                                    className="px-5 py-2 rounded-[14px] text-[12px] font-bold"
                                    style={{
                                      border: '0.75px solid rgba(148,163,184,0.7)',
                                      background: 'rgba(15,23,42,0.9)',
                                      color: '#E5E7EB',
                                    }}
                                  >
                                    إلغاء
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}

            {                                }
            {activeTab === 'course' && (
              <div className="w-full max-w-3xl mx-auto space-y-5">
                <div style={formCardStyle}>
                  <div
                    className="mb-4 flex flex-col items-end"
                    style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}
                  >
                    <h2
                      style={{
                        fontFamily: 'Alexandria',
                        fontWeight: 700,
                        fontSize: '13px',
                        marginBottom: 6,
                      }}
                    >
                      إدارة المقررات
                    </h2>
                    <p
                      style={{
                        fontFamily: 'Alexandria',
                        fontWeight: 500,
                        fontSize: '11px',
                        color: '#D5D2D2',
                        maxWidth: '480px',
                      }}
                    >
                      يمكنك تعديل بيانات المقررات أو حذفها من جدول NameCourses.courses،
                      مع إمكانية البحث في القائمة.
                    </p>
                  </div>

                  {         }
                  <div style={{ direction: 'rtl' }} className="mb-3">
                    <label className="block text-xs font-medium mb-1 text-right">
                      البحث عن مقرر
                    </label>
                    <input
                      type="text"
                      placeholder="ابحث بالاسم، الرمز، الكلية أو القسم..."
                      value={coursesSearch}
                      onChange={(e) => setCoursesSearch(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  {           }
                  {coursesInfo && (
                    <div className="mb-3 rounded-xl border border-emerald-500/60 bg-emerald-500/10 px-3 py-2 text-[12px] text-emerald-100 text-right">
                      {coursesInfo}
                    </div>
                  )}
                  {coursesError && (
                    <div className="mb-3 rounded-xl border border-rose-500/60 bg-rose-500/10 px-3 py-2 text-[12px] text-rose-100 text-right">
                      {coursesError}
                    </div>
                  )}

                  {coursesLoading ? (
                    <div className="text-center text-sm text-slate-200 mt-4">
                      جاري تحميل المقررات...
                    </div>
                  ) : filteredCourses.length === 0 ? (
                    <div className="text-center text-sm text-slate-300 mt-4">
                      لا يوجد مقررات مطابقة لشرط البحث.
                    </div>
                  ) : (
                    <div
                      className="space-y-3 mt-4"
                      style={{ direction: 'rtl', maxHeight: '520px', overflowY: 'auto' }}
                    >
                      {filteredCourses.map((course) => {
                        const isEditing = editCourseId === course.id;
                        return (
                          <div
                            key={course.id}
                            className="px-3 py-3 text-[12px]"
                          style={{ background: 'radial-gradient(55% 100% at 50% -5%,rgba(40,227,218,.10) 0%,rgba(40,227,218,0) 60%),rgba(9,28,43,.9)', border: '1px solid rgba(40,227,218,.22)', borderRadius: '14px', boxShadow: '0 4px 16px rgba(0,0,0,.25)' }}
                          >
                            <div
                              className="flex justify-between items-center mb-2 gap-2"
                              style={{ direction: 'rtl' }}
                            >
                              {               }
                              <div
                                className="flex flex-col flex-1 text-right"
                                style={{ textAlign: 'right' }}
                              >
                                <div className="flex items-center gap-2 mb-1 justify-end">
                                  <span className="text-white font-semibold">
                                    {course.name}
                                  </span>
                                  {course.code && (
                                    <span className="px-2 py-[2px] rounded-full text-[10px] bg-sky-500/10 border border-sky-400/50 text-sky-100">
                                      {course.code}
                                    </span>
                                  )}
                                </div>
                                <div className="text-[#B8C5CE]">
                                  {course.college || 'كلية غير محددة'} •{' '}
                                  {course.department || 'قسم غير محدد'}
                                </div>
                              </div>

                              {                  }
                              <div className="flex flex-col gap-2 items-start">
                                <button
                                  type="button"
                                  onClick={() =>
                                    isEditing ? cancelEditCourse() : startEditCourse(course)
                                  }
                                  style={{
                                    ...smallButtonBase,
                                    borderColor: 'rgba(40,227,218,.7)',
                                    background: isEditing
                                      ? 'rgba(40,227,218,.1)'
                                      : 'linear-gradient(135deg,#28E3DA,#7DF9E8)',
                                    color: isEditing ? '#7DF9E8' : '#081423',
                                  }}
                                >
                                  {isEditing ? 'إلغاء' : 'تعديل'}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => deleteCourse(course.id)}
                                  style={{
                                    ...smallButtonBase,
                                    borderColor: 'rgba(248,113,113,.7)',
                                    background: 'rgba(127,29,29,.9)',
                                    color: '#FEE2E2',
                                  }}
                                >
                                  حذف
                                </button>
                              </div>
                            </div>

                            {                                   }
                            {isEditing && (
                              <div
                                className="mt-3 pt-3 border-t border-white/5"
                                style={{ direction: 'rtl' }}
                              >
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      اسم المقرر
                                    </label>
                                    <input
                                      type="text"
                                      value={editCourseData.name}
                                      onChange={(e) =>
                                        handleEditCourseChange('name', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      رمز المقرر
                                    </label>
                                    <input
                                      type="text"
                                      value={editCourseData.code}
                                      onChange={(e) =>
                                        handleEditCourseChange('code', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      الكلية
                                    </label>
                                    <input
                                      type="text"
                                      value={editCourseData.college}
                                      onChange={(e) =>
                                        handleEditCourseChange('college', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[11px] mb-1 text-right">
                                      القسم
                                    </label>
                                    <input
                                      type="text"
                                      value={editCourseData.department}
                                      onChange={(e) =>
                                        handleEditCourseChange('department', e.target.value)
                                      }
                                      style={inputStyle}
                                    />
                                  </div>
                                </div>

                                <div className="flex justify-center mt-3 gap-3">
                                  <button
                                    type="button"
                                    onClick={saveCourseEdit}
                                    disabled={editCourseLoading}
                                    className="px-5 py-2 rounded-[14px] text-[12px] font-bold"
                                    style={{
                                      border: '0.75px solid rgba(40,227,218,0.6)',
                                      background: editCourseLoading
                                        ? 'rgba(40,227,218,0.25)'
                                        : 'linear-gradient(135deg,#28E3DA,#7DF9E8)',
                                      color: '#081423',
                                      boxShadow: '0 0 18px rgba(40,227,218,.55)',
                                      opacity: editCourseLoading ? 0.8 : 1,
                                    }}
                                  >
                                    {editCourseLoading ? 'جاري الحفظ...' : 'حفظ التعديل'}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={cancelEditCourse}
                                    className="px-5 py-2 rounded-[14px] text-[12px] font-bold"
                                    style={{
                                      border: '0.75px solid rgba(148,163,184,0.7)',
                                      background: 'rgba(15,23,42,0.9)',
                                      color: '#E5E7EB',
                                    }}
                                  >
                                    إلغاء
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <MobileBottomNav />
      </div>
    </div>
  );
};

export default ManageCourseLecturerPage;
